import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import Hero from '@/components/Hero';
import Header from '@/components/Header';
import SEO from '@/components/SEO';

const Index = () => {
  const { setTheme } = useTheme();
  
  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <div className="h-screen w-screen overflow-hidden fixed inset-0 touch-none overscroll-none">
      <SEO
        title="Freeman & Crown Law"
        description="Empowering competent men and women of the Republic to reclaim their freedom. Attorneys in fact specializing in tax law, constitutional law, and trust law. Guided by truth, honor, and justice."
        image="/lovable-uploads/71fa2df8-9429-454b-a2ba-604271a8b424.png"
        url={window.location.origin + '/'}
        type="website"
      />
      <Header />
      <Hero />
    </div>
  );
};

export default Index;
